import Vue from "vue";
import VueRouter from "vue-router";
import { home } from "@/router/intranet/home/home.js";
import { 
    login,
    loginPassRecover
} from "@/router/intranet/login/login.js";
import { Cumpleanios } from "@/router/intranet/cumpleanios/cumpleanios.js";
import { cultura } from "@/router/intranet/cultura/cultura.js";
import {
    organigrama,
    organigramaSingle,
} from "@/router/intranet/organigrama/organigrama.js";
import {
    encuesta,
    encuestaSingle,
} from "@/router/intranet/encuesta/encuesta.js";
import {
    galeria,
    galeriaAlbumes,
    galeriaAlbumSingle,
} from "@/router/intranet/galeria/galeria.js";
import {
    noticias,
    noticiasSingle,
} from "@/router/intranet/noticias/noticias.js";
import {
    teamworkupTV,
    teamworkupTVSingle,
} from "@/router/intranet/teamworkup-tv/teamworkup-tv.js";
import { seguridad } from "@/router/intranet/seguridad/seguridad.js";
import { biblioteca } from "@/router/intranet/biblioteca/biblioteca.js";
import {
    reconoce,
    reconoceId,
    formReconoceView
} from "@/router/intranet/reconoce/reconoce.js";
import { folovid } from "@/router/intranet/folovid/folovid.js";
import {
    hoteleria,
    hoteleriaSolicitudes,
} from "@/router/intranet/hoteleria/hoteleria.js";
import {
    transporte,
    transporteFormulario,
} from "@/router/intranet/transporte/transporte.js";
import { desayuno } from "@/router/intranet/desayuno/desayuno.js";
import { miPerfil } from "@/router/intranet/mi-perfil/mi-perfil.js";

//FF
import { beneficios } from "@/router/intranet/beneficios/beneficios.js";

Vue.use(VueRouter);

const routes = [
    { path: "*", redirect: "/inicio" },
    home,
    login,
    loginPassRecover,
    Cumpleanios,
    cultura,
    organigrama,
    organigramaSingle,
    encuesta,
    encuestaSingle,
    galeria,
    noticias,
    noticiasSingle,
    teamworkupTV,
    teamworkupTVSingle,
    seguridad,
    biblioteca,
    galeriaAlbumes,
    galeriaAlbumSingle,
    reconoce,
    formReconoceView,
    folovid,
    hoteleria,
    hoteleriaSolicitudes,
    transporte,
    transporteFormulario,
    desayuno,
    miPerfil,
    reconoceId,
    beneficios
];
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;